import React from 'react';

// MUI
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const WelcomeModelCard = (props: { icon: React.JSX.Element, title: string, description: string }) => {

  const { icon, title, description } = props

  return (
    <Stack display="flex" flexDirection="column" alignItems="center" gap={3} mt={2} maxWidth={{
      xs: "100%",
      md: "350px"
    }}>
      {icon}
      <Typography variant="h6" fontSize="1.3rem">
        {title}
      </Typography>
      <Typography variant="body2" color="black" width="80%" fontSize="1.1rem" textAlign={{
        xs: "center",
        md: "left"
      }}>
        {description}
      </Typography>
    </Stack>
  )
}

export default WelcomeModelCard;
